import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { ColorsV2, getToken } from '@electricjs/arc';

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${getToken(ColorsV2.GRAY_DARKEST)};

  &:hover {
    text-decoration: underline;
  }
`;

export default StyledLink;
